import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux"
// store
import AppStore from "@/app-store";
import Store from "@/core/reducers/SimpleServiceStore";
// actions
import ClientPagesServiceAction from "@/cms/actions/services/ClientPagesServiceAction";
// types
import TOdataQueryOptions from "@/core/types/TOdataQueryOptions";
import TClientPageList from "@/cms/types/TClientPageList";
// enums
import EContentStatus from "@/cms/enums/EContentStatus";
import TBaseReduxStoreState from "@/core/types/TBaseReduxStoreState";
import TValidations from "@/cms/types/TValidations";


type TUsePagesIn = {

    unqKey:string;
    categoryId:string;
    top?:number;
    orderBy?:string[];

}

const usePages = ( props:TUsePagesIn ):TBaseReduxStoreState<TClientPageList[]|null,TValidations[]|null> => {
    const dispatch = useDispatch();

    const { unqKey, categoryId, top, orderBy } = props;

    const clientPagesServiceAction = new ClientPagesServiceAction(dispatch, unqKey);
    AppStore.reducerManager.add(unqKey, Store(unqKey, clientPagesServiceAction.serviceCode));
    const payload = useSelector((state:any) => state?.[unqKey]?.list, shallowEqual);
    const webApplicationLanguageCode = useSelector((state:any) => state.CoreStore.language?.payload?.code, shallowEqual);

    useEffect(() => { return () => { AppStore.reducerManager.remove(unqKey) } },[]);
    useEffect(() => { if ( categoryId ) _list() }, [categoryId])

    const _list = () => {
        let queryOptions:TOdataQueryOptions = {
            filter: [`status eq ${EContentStatus.ACTIVE}`, "and", `contentId eq ${categoryId}`],
            orderBy: orderBy,
            top: top
        }
        clientPagesServiceAction.search({ servicePayload: { queryOptions, language: webApplicationLanguageCode } });
    }

    return payload;
}

export default usePages;
